/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { InsightsSectionComponent } from '../../../details-page/components/insights-section/insights-section.component';
import { User } from '../../../../../../models/User';

@Component({
  selector: 'app-app-ad-spend-section',
  templateUrl: './app-ad-spend-section.component.html',
  styleUrls: [
    '../../../details-page/components/insights-section/insights-section.component.scss',
    './app-ad-spend-section.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppAdSpendSectionComponent
  extends InsightsSectionComponent
  implements OnInit
{
  hasAdSpendPermission: boolean;

  constructor(private userService: User, _changeDetector: ChangeDetectorRef) {
    super(_changeDetector);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.hasAdSpendPermission = this.hasAdSpendPermission =
      this.userService.appAdSpendEnabled();
  }
}
